import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-GB';
import itLocale from 'date-fns/locale/it';
import { frFR, enUS, itIT } from '@mui/x-date-pickers';

const localeFiles = {
  fr: {
    adapter: frLocale,
    text: frFR.components.MuiLocalizationProvider.defaultProps.localeText
  },
  en: {
    adapter: enLocale,
    text: enUS.components.MuiLocalizationProvider.defaultProps.localeText
  },
  it: {
    adapter: itLocale,
    text: itIT.components.MuiLocalizationProvider.defaultProps.localeText
  }
};
const DatePickerProvider = ({
  children,
  locale
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  locale: 'fr' | 'en' | 'it';
}) => {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={localeFiles[locale].adapter || enLocale}
      localeText={localeFiles[locale]?.text}
    >
      {children}
    </LocalizationProvider>
  );
};

export { DatePickerProvider };
